<template>
  <block-view style="padding: 0" class="ad">
    <a-carousel autoplay :dots="false">
      <router-link to="/service/vip"><img src="@/assets/image/vip_ad1.jpg" alt=""/></router-link>
      <router-link to="/service/vip"><img src="@/assets/image/vip_ad2.jpg" alt=""/></router-link>
      <router-link to="/service/vip"><img src="@/assets/image/vip_ad3.jpg" alt=""/></router-link>
      <router-link to="/service/vip"><img src="@/assets/image/vip_ad4.jpg" alt=""/></router-link>
    </a-carousel>
  </block-view>
</template>

<script setup lang="ts">

import BlockView from "@/views/share/BlockView.vue";
</script>

<style scoped lang="sass">
.ad
  padding: 0
  border-radius: 10px
  overflow: hidden

  :deep(.slick-slide)
    height: 179px

</style>